// LiveStream.tsx
import React, { useRef, useEffect } from "react";
import { SrsRtcWhepAsync } from "./SrsRtcWhepAsync";
import { videoMainStreamId } from "../App";

interface LiveStreamProps {
  url: string; // WHEP URL to liveserver.studios.id
}

const LiveStream: React.FC<LiveStreamProps> = ({ url }) => {
  const whepClientRef = useRef<SrsRtcWhepAsync | null>(null);

  useEffect(() => {
    const initializePlayer = async () => {
      try {
        whepClientRef.current = new SrsRtcWhepAsync();
        whepClientRef.current.ontrack = (event: RTCTrackEvent) => {
          console.log("EVENT: WHEP CLIENT REF ONTRACK CALLED " + event.track.kind);

          const mainEl: HTMLVideoElement = document.getElementById(
            videoMainStreamId
          ) as HTMLVideoElement;
          const fullEl: HTMLVideoElement = document.getElementById(
            videoMainStreamId + "-full"
          ) as HTMLVideoElement;
        
          if (!mainEl.srcObject) {
            mainEl.srcObject = new MediaStream();
          }
          if (!fullEl.srcObject) {
            fullEl.srcObject = new MediaStream();
          }

          (mainEl.srcObject as MediaStream).addTrack(event.track);
          (fullEl.srcObject as MediaStream).addTrack(event.track);

          // Get Shopkeeper Element
          const shopkeeperEl = document.getElementById(
            videoMainStreamId + "-shopkeeper"
          );
          if (shopkeeperEl) {
            if (!(shopkeeperEl as HTMLVideoElement).srcObject) {
              (shopkeeperEl as HTMLVideoElement).srcObject = new MediaStream();
            }
            ((shopkeeperEl as HTMLVideoElement).srcObject as MediaStream).addTrack(event.track);
          }

          // Get Shopkeeper Element
          const lsIntroEl = document.getElementById(
            videoMainStreamId + "-lsintro"
          );
          if (lsIntroEl) {
            if (!(lsIntroEl as HTMLVideoElement).srcObject) {
              (lsIntroEl as HTMLVideoElement).srcObject = new MediaStream();
            }
            ((lsIntroEl as HTMLVideoElement).srcObject as MediaStream).addTrack(event.track);
          }
        
          if (event.track.kind === "audio") {
            console.log("Audio track added");
          } else if (event.track.kind === "video") {
            console.log("Video track added");
          }
        };

        await whepClientRef.current.play(url);
      } catch (error) {
        console.error("Failed to initialize player:", error);
      }
    };

    if (url) {
      initializePlayer();
    }

    return () => {
      if (whepClientRef.current) {
        whepClientRef.current.close();
      }
      
      const mainEl: HTMLVideoElement = document.getElementById(
        videoMainStreamId
      ) as HTMLVideoElement;
      const fullEl: HTMLVideoElement = document.getElementById(
        videoMainStreamId + "-full"
      ) as HTMLVideoElement;
      const shopkeeperEl: HTMLVideoElement = document.getElementById(
        videoMainStreamId + "-shopkeeper"
      ) as HTMLVideoElement;
      const lsIntroEl: HTMLVideoElement = document.getElementById(
        videoMainStreamId + "-lsintro"
      ) as HTMLVideoElement;

      if (mainEl) {
        (mainEl.srcObject as MediaStream).getVideoTracks().forEach(track => {
          track.stop();
          (mainEl.srcObject as MediaStream).removeTrack(track);
        });
        mainEl.srcObject = null;
      }
      if (fullEl) {
        (fullEl.srcObject as MediaStream).getVideoTracks().forEach(track => {
          track.stop();
          (fullEl.srcObject as MediaStream).removeTrack(track);
        });
        fullEl.srcObject = null;
      }
      if (shopkeeperEl) {
        (shopkeeperEl.srcObject as MediaStream).getVideoTracks().forEach(track => {
          track.stop();
          (shopkeeperEl.srcObject as MediaStream).removeTrack(track);
        });
        shopkeeperEl.srcObject = null;
      }
      if (lsIntroEl) {
        (lsIntroEl.srcObject as MediaStream).getVideoTracks().forEach(track => {
          track.stop();
          (lsIntroEl.srcObject as MediaStream).removeTrack(track);
        });
        lsIntroEl.srcObject = null;
      }
    };
  }, [url]);

  return <div />;
};

export default LiveStream;
